import { Routes } from '@angular/router';
import { GdlComponent } from './features/gdl/gdl.component';
import { ChennaiComponent } from './features/chennai/chennai.component';
import { ProjectDetailComponent } from './features/project-detail/project-detail.component';
import { AdminComponent } from './features/admin/admin.component';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: 'guadalajara',
    component: GdlComponent,
  },
  {
    path: 'chennai',
    component: ChennaiComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [adminGuard],
  },
  {
    path: 'project/:name',
    component: ProjectDetailComponent,
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
